
webpack.register(
    'modules/right-rail/biggest-movers/biggest-movers',
    function() {
        return import('modules/right-rail/biggest-movers/biggest-movers');
    },
    true
);